<script lang="ts" setup>
import { ref } from 'vue'

import TradingFooter from '@/components/TradingBlock/TradingFooter.vue'
import { __ } from '@/utils/utils'

const props = defineProps({ data: Object })

const traderOptions = [
  props?.data?.metatrader_4_dropdown_label,
  props?.data?.metatrader_dropdown_5_label
]

const isDropdownOpen = ref(false)
const selectedTrader = ref(props?.data?.metatrader_4_dropdown_label)

const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value
}

const selectTrader = (trader: string) => {
  isDropdownOpen.value = false
  selectedTrader.value = trader
}
</script>
<template>
  <div class="flex flex-col lg:flex-row">
    <div
      class="flex flex-col lg:justify-start items-center lg:items-start w-full lg:max-w-[346px] mt-10 lg:ml-10"
    >
      <div>
        <img loading="lazy" :src="data?.logo" :alt="data?.logo_alt" />
      </div>
      <div
        class="w-full mt-5 text-base px-[10px] lg:px-[0px] lg:w-[311px] lg:h-[145px] -tracking-tightest"
      >
        {{ data?.description }}
      </div>
      <div class="relative flex flex-col items-center justify-center w-full mt-10 lg:hidden">
        <div class="clip-bottom-135">
          <img loading="lazy" :src="data?.main_image" :alt="data?.main_image.alt" />
        </div>
        <div class="absolute z-10 h-[330px] w-full bg-gradient-to-t from-white"></div>
      </div>
      <div
        class="lg:mt-5 mt-0 w-full md:px-0 px-[10px] flex flex-col justify-center md:max-w-[311px]"
      >
        <div class="flex justify-center w-full md:max-w-[310px]">
          <div class="w-full">
            <div class="">{{ data?.mt_dropdown_selector_title }}</div>

            <button
              class="relative flex justify-start w-full cursor-pointer border-[2px] border-gray-350 leading-5 py-4"
              type="button"
              @click="toggleDropdown()"
            >
              <div class="flex">
                <div class="text-base leading-[19px] ml-[10px]">{{ selectedTrader }}</div>
              </div>
              <div class="absolute flex right-3 top-[22px] fill-black">
                <img
                  v-if="!isDropdownOpen"
                  loading="lazy"
                  src="/assets/dropdown-arrow-down-black.svg"
                />
                <img
                  v-if="isDropdownOpen"
                  loading="lazy"
                  src="/assets/dropdown-arrow-up-black.webp"
                />
              </div>
            </button>
            <div
              :class="{ hidden: !isDropdownOpen }"
              class="relative z-50 text-sm list-none bg-white divide-y divide-gray-100"
            >
              <ul class="absolute w-full bg-white shadow-md">
                <li
                  :class="selectedTrader === traderOptions[0] ? 'bg-gray-100' : ''"
                  class="cursor-pointer"
                  @click="selectTrader(data?.metatrader_4_dropdown_label)"
                >
                  <div class="flex items-center w-full ml-1 text-sm" role="menuitem">
                    <div class="inline-flex items-center py-4 text-base leading-[19px] ml-[10px]">
                      {{ data?.metatrader_4_dropdown_label }}
                    </div>
                  </div>
                </li>
                <li
                  :class="selectedTrader === traderOptions[1] ? 'bg-gray-100' : ''"
                  class="cursor-pointer"
                  @click="selectTrader(data?.metatrader_dropdown_5_label)"
                >
                  <div class="flex items-center w-full ml-1 text-sm" role="menuitem">
                    <div class="inline-flex items-center py-4 text-base leading-[19px] ml-[10px]">
                      {{ data?.metatrader_dropdown_5_label }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="flex mt-[10px] lg:justify-between justify-center gap-2.5 lg:gap-0">
          <button type="button">
            <a
              :href="
                selectedTrader === traderOptions[0]
                  ? data?.metatrader_4_dropdown_link_google_play_store
                  : data?.matatrader_5_dropdown_link_google
              "
              target="_blank"
            >
              <picture>
                <source media="(max-width: 600px)" :srcset="data?.google_play_icon_mobile" />
                <source media="(min-width: 601px)" :srcset="data?.google_play_icon" />
                <img loading="lazy" :src="data?.google_play_icon" />
              </picture>
            </a>
          </button>
          <button type="button">
            <a
              :href="
                selectedTrader === traderOptions[0]
                  ? data?.metatrader_4_dropdown_link_app_store
                  : data?.metatrader_5_dropdown_link_apple
              "
              target="_blank"
            >
              <picture>
                <source media="(max-width: 600px)" :srcset="data?.app_store_icon_mobile" />
                <source media="(min-width: 601px)" :srcset="data?.app_store_icon" />
                <img loading="lazy" :src="data?.app_store_icon" />
              </picture>
            </a>
          </button>
        </div>
      </div>
    </div>
    <div class="lg:flex flex-col items-center justify-center w-full mt-18.5 relative hidden">
      <div class="clip-bottom-135">
        <img loading="lazy" :src="data?.main_image" :alt="data?.main_image.alt" />
      </div>
      <div class="absolute z-10 h-[330px] w-full bg-gradient-to-t from-white"></div>
    </div>
  </div>
  <TradingFooter
    :titleOne="data?.footer_column_one_title"
    :contentOne="data?.footer_column_one_content"
    :titleTwo="data?.footer_column_two_title"
    :contentTwo="data?.footer_column_two_content"
    :titleThree="data?.footer_column_three_title"
    :contentThree="data?.footer_column_three_content"
    :titleFour="data?.footer_column_four_title"
    :contentFour="data?.footer_column_four_content"
    :footerIconLink="data?.footer_icon"
    :footerIconAlt="data?.footer_icon_alt"
    class="relative bottom-[27px] lg:mb-[53px]"
  ></TradingFooter>
</template>
